// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DuN9","fullView":"styles_fullView__2fmPD"};